const siteId = process.env.REACT_APP_BUILD_SITE;

export const hotjarIdsByPortal = {
  ZPAR: 194887,
  '24MX': 174024,
  CAPA: 212842,
  DVPE: 212841,
  UBPE: 1520729,
  ICBR: 190143,
  IWBR: 190143,
  LLVE: 212843,
  PLEC: 212844,
  WIBR: 629215,
  CMBR: 3082812,
  VAMX: 174024
};

const userType = {
  '1': 'Administrador',
  '2': 'Superusuario',
  '3': 'Usuario',
  '4': 'Asistente',
  '20': 'Vendedor',
  '40': 'Vendedor',
  '100': 'Seeker',
  '101': 'Seeker',
  '102': 'Anonymous'
};

const publisherType = {
  '1': 'Dueño Directo',
  '2': 'Inmobiliaria',
  '3': 'Constructora',
  '4': 'Corredor'
};
export const getHotjarId = () => hotjarIdsByPortal[siteId];

export const setHotjarIdentify = (hotjar, userInfo) => {
  const { publisherTypeId, userTypeId, isIntegrator, premier, publisherId } = userInfo;
  if (hotjar && userTypeId) {
    hotjar('identify', publisherId, {
      'Publisher type': publisherType[publisherTypeId] || null,
      Premier: premier ? 'Si' : 'No',
      Integra: isIntegrator ? 'Si' : 'No',
      'User type': userType[userTypeId] || null
    });
  }
};
